<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item
            v-if="isMobile() && !filterShow"
            label="报价单号"
            prop="number"
          >
            <el-input
              size="small"
              v-model="filter.number"
              @keyup.enter.native="requestQuotations"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <div class="filter-block" v-show="filterShow || !isMobile()">
            <el-form-item label="报价单号" prop="number">
              <el-input
                size="small"
                v-model="filter.number"
                @keyup.enter.native="requestQuotations"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户" prop="customer_id">
              <!-- <el-select
                size="small"
                v-model="filter.customer_id"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in customers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select> -->
              <customer-select
                style="width: 100%"
                :val="filter.customer_id"
                @change="filter.customer_id = $event"
              ></customer-select>
            </el-form-item>
            <el-form-item label="状态" prop="status" v-if="this.status <= 0">
              <el-select
                size="small"
                v-model="filter.status"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, key) in statusOptions"
                  :key="key"
                  :label="item.name"
                  :value="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="销售"
              prop="user_id"
              v-permission="Auth.userList"
            >
              <el-select
                size="small"
                v-model="filter.user_id"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sales"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="日期" prop="date">
              <el-date-picker
                style="width: 360px"
                v-model="filter.date"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button type="primary" size="small" @click="requestQuotations()"
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i
              class="text-gray"
              :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            ></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startQuotation"
          v-permission="Auth.quotationNew"
          >新报价</el-button
        >
      </div>
      <el-table v-if="!isMobile()" :data="quotations" v-loading="loading">
        <el-table-column prop="number" label="报价单号/客户/项目" width="200px">
          <template slot-scope="scope">
            <quotation-link :quotation="scope.row" :origin="2"></quotation-link>
            <br />
            <span>{{ scope.row.customer.name }}</span>
            <template v-if="scope.row.order_info.project_name.length > 0">
              <br />
              <span>{{ scope.row.order_info.project_name }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="产品明细">
          <template slot-scope="scope">
            <template v-for="device in scope.row.order_info.devices">
              <span class="item-tag" v-for="item in device.items">
                {{ item.item.name }}
                <i>x{{ item.count }}</i>
              </span>
            </template>
            <span
              class="item-tag"
              v-for="item in scope.row.order_info.products"
            >
              {{ item.item.part_number }}
              <i>x{{ item.count }}</i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sale" label="销售" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="日期" width="150" align="center">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额(￥)"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.order_info.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <status-tag
              v-if="deleted == 0"
              :type="QuotationStatusMap[scope.row.status].type"
              :name="QuotationStatusMap[scope.row.status].name"
            ></status-tag>
            <status-tag v-else type="gray" name="已删除"> </status-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <quotation-link
              :quotation="scope.row"
              :origin="2"
              v-permission="Auth.quotationShow"
            >
              <el-button slot="content" size="mini" type="primary" plain
                >查看详情</el-button
              >
            </quotation-link>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="q in quotations">
          <div class="flex-row-between">
            <quotation-link :quotation="q" :origin="2"></quotation-link>
            <span>￥{{ q.order_info.amount }}</span>
          </div>
          <div class="font-12">客户：{{ q.customer.name }}</div>
          <div class="font-12 flex-row-between">
            <span>销售：{{ q.user.name }}</span>
          </div>
          <div class="font-12 flex-row-between">
            <span>{{ formatTime(q.created_at) }}</span>
            <span>
              <status-tag
                v-if="deleted == 0"
                :type="QuotationStatusMap[q.status].type"
                :name="QuotationStatusMap[q.status].name"
              ></status-tag>
              <status-tag v-else type="gray" name="已删除"> </status-tag
            ></span>
          </div>
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <customer-selector
      :show.sync="customerSelectorVisible"
      :activeCustomers="activeCustomers"
      @selected="selectedQuotationCustomer"
    ></customer-selector>
  </div>
</template>

<script>
import {
  customerList,
  userList,
  customerOrderList,
  quotationList,
  customerActiveList,
} from '../../service/getData'
import { QuotationStatusMap } from '../../config/global'
import auth from '@/util/auth'
import { clone } from '@/util'
import { formatTime } from '@/util/index'
import CustomerSelector from '@/components/customer_selector'
import { hasAuth } from '@/permission'
import { isMobile, scrollToTop } from '../../util'
import CustomerSelect from '@/components/select/customer_select'

export default {
  components: { CustomerSelector, CustomerSelect },
  props: {
    deleted: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isMobile,
      scrollToTop,
      filter: {
        number: '',
        customer_id: '',
        status: '',
        date: null,
        user_id: '',
        size: 20,
        page: 1,
      },
      filterShow: false,
      total: 0,
      sales: [],
      customers: [],
      quotations: [],
      auth,
      customerSelectorVisible: false,
      activeCustomers: [],
      QuotationStatusMap,
      statusOptions: {},
      formatTime: formatTime,
      loading: false,
    }
  },
  created() {
    // this.requestCustomers()

    if (hasAuth('userList')) {
      this.requestSales()
    }

    this.requestQuotations()

    this.statusOptions = clone(QuotationStatusMap)
    if (this.status <= 0) {
      delete this.statusOptions[5]
    }
  },
  methods: {
    async requestCustomers() {
      let res = await customerList()
      if (res.code == 0) {
        this.customers = res.data.list
      }
    },
    async requestSales() {
      let res = await userList()
      if (res.code == 0) {
        this.sales = res.data.list
      }
    },
    async requestQuotations() {
      let data = clone(this.filter)
      data.page = data.page - 1
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }
      this.loading = true
      if (this.status > 0) {
        data.status = this.status
      } else if (this.status < 0) {
        data.not_status = -this.status
      }
      data.deleted = this.deleted
      let res = await quotationList(data)
      if (res.code == 0) {
        this.quotations = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    async requestActiveCustomer() {
      let res = await customerActiveList()
      if (res.code == 0) {
        this.activeCustomers = res.data.list
      }
    },
    startQuotation() {
      this.requestActiveCustomer()
      this.customerSelectorVisible = true
    },
    selectedQuotationCustomer(customer) {
      this.$router.push('/dashboard/new_quotation?customer=' + customer.id)
    },
    reset() {
      this.$refs['filterForm'].resetFields()
      this.filter.page = 1
      this.requestQuotations()
    },
  },
}
</script>

<style scoped>
.el-input {
  width: 220px;
}
</style>